// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { BootstrapImage } from '../../dsl/front'

import { AbstractModuleUi, FetchesRelatedAsync } from '../_abstract/ui'
import { Image, ImageFile, ImageRatio } from '../_contracts'
import { ModuleHeaderUi } from '../_components/ui'
import { prepareImage } from '../_filters'

import { AboutModule } from './About.contracts'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component<AboutModuleUi>({
  name: 'AboutModuleUi',
  components: {
    BootstrapImage,
    ModuleHeaderUi
  },

  async created () {
    await this.fetchRelated()
  },

  template: `
    <section class="about-module" :style="{ background }">
    <div class="container">
      <div class="row justify-content-center">

        <!-- Header -->
        <div class="col-12 col-md-10 col-lg-8">
          <ModuleHeaderUi v-if="module.content.header" :header="module.content.header"/>
        </div>

        <!-- Image -->
        <div v-if="resolvedImage" class="col-12">
          <BootstrapImage v-bind="resolvedImage" class="about-module__image"/>
        </div>

        <!-- Stats -->
        <div class="col-12">
          <dl v-if="module.content.stats && module.content.stats.length" class="about-module__stats">
            <div v-for="(stat, index) in module.content.stats" :key="index" class="about-module__stat">
              <dt v-if="stat.label" v-html="stat.label" class="about-module__stat__title"/>
              <dd class="about-module__stat__description">
                <span v-if="stat.value" v-html="stat.value" class="about-module__stat__value"/>
                <span v-if="stat.unit" v-html="stat.unit" class="about-module__stat__unit"/>
              </dd>
            </div>
          </dl>
        </div>
        <!-- END | Stats -->

        <!-- Text -->
        <div class="col-12 col-md-10 col-lg-8">
          <p v-if="module.content.text" v-html="module.content.text" class="about-module__text"/>
        </div>

      </div>
    </div>
    </section>
  `
})
export class AboutModuleUi extends AbstractModuleUi<AboutModule> implements FetchesRelatedAsync {
  public resolvedImage: Image | null = null

  /**
   * @inheritDoc
   */
  public async fetchRelated (): Promise<void> {
    if (this.module.content.image === null) {
      return
    }

    try {
      const imageFile: ImageFile = await this.relatedService.resolve(this.module.content.image) as ImageFile
      const maxWidth: number | undefined = this.isMobile ? 768 : 1220
      this.resolvedImage = prepareImage(imageFile, this.imageRatio, maxWidth, this.module.isLazyLoaded)
      this.onReady()
    } catch (e) {
      this.onError(e)
    }
  }
}
